import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip } from "chart.js";
import { Pie } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip);

// Chart.js's registry is global: a page that loads `chart.js/auto` elsewhere
// (e.g. the account credits chart, via App.js) registers the Legend plugin
// for every chart. Turn it off here so this chart looks the same everywhere.
const options = { plugins: { legend: { display: false } } };

function ScopeStackPieChart({ data, width, height }) {
  return (
    <Pie
      style={{ width: width, height: height }}
      data={data}
      options={options}
    />
  );
}

export default ScopeStackPieChart;
